export default __webpack_public_path__ + "static/media/wi-fi.04efec9d.svg";